export function messageBtn() {
  $('.p-messageOther_btn').on('click', function(){
    if ( $(this).hasClass('is-open02')) {
      $(this).removeClass('is-open02 is-open');
      $(this).children().text('先輩からのメッセージをもっと見る');
      $('.p-messageOther_cont').removeClass('is-view');
      var backscroll = $('.p-messageOther').offset().top - 200;
      // $(window).scrollTop(backscroll - '300px');
      $('html, body').animate({scrollTop:backscroll});
    } else if($(this).hasClass('is-open')) {
      $(this).addClass('is-open02');
      $(this).children().text('閉じる');
      $('.p-messageOther_cont').addClass('is-view');
    } else {
      $(this).addClass('is-open');
      for (var i=0; i< 10; i++) {
        $('.p-messageOther_cont').eq(i).addClass('is-view');
      }
    }
  });
}